/**
 * Function to add Cookiebot to the head of the document
 */
(function (window, document) {
  const head = document.getElementsByTagName('head')[0];

  if (document.querySelector("script[src*='consent.cookiebot.com/uc.js']")) {
    console.warn('Cookiebot is already added.');
    return;
  }

  // We temporarily hide the Cookiebot dialog and show it via app root component
  const style = document.createElement('style');
  style.innerHTML = `
    #CybotCookiebotDialog,
    #CybotCookiebotDialogBodyUnderlay {
      display: none !important;
    }
  `;

  head.appendChild(style);

  function removeTemporaryHiddenStyle() {
    if (style.parentNode) {
      style.parentNode.removeChild(style);
    }
  }

  // CMP Banner
  const scriptCookiebot = document.createElement('script');
  scriptCookiebot.id = 'Cookiebot';
  scriptCookiebot.src = 'https://consent.cookiebot.com/uc.js?cbid=7e6b866a-2b2e-44dc-8672-2c7894391fd8&amp;consentmode-dataredaction=dynamic';
  scriptCookiebot.type = 'text/javascript';
  scriptCookiebot.async = true;
  head.insertBefore(scriptCookiebot, head.firstChild);

  window.cookiebotLoader = {
    removeTemporaryHiddenStyle: removeTemporaryHiddenStyle,
  };
})(window, document);

/**
 * Function to add Google Tag Manager to the head of the document
 */
(function (window, document) {
  const head = document.getElementsByTagName('head')[0];

  if (document.querySelector("script[src*='googletagmanager.com/gtm.js']")) {
    console.warn('Google Tag Manager is already added.');
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('data-cookieconsent', 'ignore');
  script.async = true;
  script.text = `
    window.dataLayer = window.dataLayer || [];

    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-MT46LWTL');
  `;

  head.appendChild(script);
})(window, document);
